export default __webpack_public_path__ + "static/medial-hero-video-a6cc6ddbca267c71c465afba35951e32.jpg";